import { useClientPortfolioStore } from '@/stores/client-portfolio'
import { usePortfolioStore } from '@/stores/portfolio'
import { useUserStore } from '@/stores/user'

import type { UserSession } from '@/types/services/user'

export function useSessionEffects() {
  const userStore = useUserStore()
  const clientPortfolioStore = useClientPortfolioStore()
  const portfolioStore = usePortfolioStore()

  userStore.$onAction(({ name, args }) => {
    if (name !== 'changeSession') {
      return
    }

    const [session] = args as [UserSession]
    if (userStore.isSameSession(session)) {
      return
    }

    clientPortfolioStore.$reset()
    portfolioStore.$reset()
  })
}
